import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

interface CalculatePriceCard {
  wantListId: number;
  condition: string;
  language: string;
  foil: boolean;
  set?: string;
}

interface CalculatePriceRequest {
  cards: CalculatePriceCard[];
}

interface CalculatePriceResponse {
  cards: Array<{
    wantListId: number;
    displayPrice: number;
  }>;
}

export const tradePriceApi = createApi({
  reducerPath: 'tradePriceApi',
  baseQuery,
  endpoints: (builder) => ({
    calculatePrice: builder.mutation<CalculatePriceResponse, CalculatePriceRequest>({
      query: (data) => ({
        url: '/trades/calculate-price',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useCalculatePriceMutation } = tradePriceApi;